import { Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import styles from "../../../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import { GenericDataContext, GenericDataContextPayload } from '../../../../../../context/genericDataContext';
import { channelsBreadcrumb, homeBreadcrumb, phoneNumbersBreadcrumb } from '../../../../../../utils/breadcrumb';
import { IntegrationContext, IntegrationContextPayload } from '../../../../../../context/integrationContext';
import { contactChatbotAssignmentData, metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../../../../../models/axiosModel';
import GlobalButton from '../../../../../utility/globalButton/button';
import CustomRecipientTable from './customRecipientTable';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import GlobalPopUp from '../../../../../utility/globalPopUp';
import AssignCustomRecipientPopup from './assignCustomRecipientPopup';
import { getSelectedPhoneNumber } from '../whatsAppIntegrationConstant'; 
import { getPhoneNumber, getWabaName, hasCustomRecipientManageAccess } from '../../../../../../utils/constants';

const CustomRecipient = () => {

    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { getMetaIntegrationList, integrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { apiRoutesPermissionAssignment, userDetail } = useContext(UserContext) as UserContextPayload;

    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    const phoneNumberId = searchParams.get('phonenumberId');

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const [flagOpenAssignContactPopup, setFlagOpenAssignContactPopup] = useState<boolean>(false); 
    const [contactChatbotData, setContactChatbotData] = useState<contactChatbotAssignmentData[] | null>(null);

    async function getmetaIntegrationList() {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const res = await getMetaIntegrationList(true)
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    useEffect(() => {
        const updatedBreadcrumbs = [
            homeBreadcrumb,
            { ...channelsBreadcrumb },
            { name: getWabaName(integrationListNewStructure, Number(searchParams.get('id')), "Whatsapp"), path: `/channels/viewintegration/Whatsapp?id=${id}`, isActive: false },
            { ...phoneNumbersBreadcrumb, path: `/channels/viewintegration/whatsapp/phonenumbers?id=${id}` }, 
            { name: getPhoneNumber(integrationListNewStructure, Number(searchParams.get('id')), phoneNumberId, "Phone Number"), path: `/channels/viewintegration/whatsapp/phonenumbers/customRecipient?id=${id}&phonenumberId=${phoneNumberId}`, isActive: true }
        ];
        setBreadCrumbs(updatedBreadcrumbs);
    }, [id, integrationListNewStructure, phoneNumberId]);

    useEffect(() => {
        if(!integrationListNewStructure){
            getmetaIntegrationList();   
        }
    }, [])

    useEffect(() => {
        if(integrationListNewStructure){
            const selectedPhoneNumber = getSelectedPhoneNumber(integrationListNewStructure, id, phoneNumberId);
            if(selectedPhoneNumber){
                setContactChatbotData(selectedPhoneNumber.contact_chatbot_assignment_data);
            }
        }
    }, [integrationListNewStructure])

    return (
        <>
            <Grid container className={`${globalStyles.flexColumn} ${globalStyles.fullwidth} ${styles.customRecipientMainContainer}`} gap={2}>
                <Grid item xs={12} className={`${globalStyles.fullwidth}`}>
                    <Grid container className={`${globalStyles.contentEnd}`}>
                        <Grid item>
                            {hasCustomRecipientManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                <GlobalButton
                                    buttonText="Assign Recipient" 
                                    className='primaryButtonStyle'
                                    sx={{ width: "180px !important" }}
                                    onClick={() => setFlagOpenAssignContactPopup(true)}
                                />
                            }
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={`${globalStyles.fullwidth}`}>
                    <CustomRecipientTable
                        contactChatbotData={contactChatbotData}
                        getmetaIntegrationList={getmetaIntegrationList}
                    />
                </Grid>
            </Grid>

            {flagOpenAssignContactPopup && 
                <GlobalPopUp
                    open={flagOpenAssignContactPopup}
                    onClose={() => { setFlagOpenAssignContactPopup(false); }}
                    handleClose={() => { setFlagOpenAssignContactPopup(false); }}
                    flagShowCloseIcon={true}
                    paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "850px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "850px"}
                    borderRadius='10px'
                    titlePadding='0px'
                    overflow="hidden"
                >
                    <AssignCustomRecipientPopup
                        setFlagOpenAssignContactPopup={setFlagOpenAssignContactPopup}
                        getmetaIntegrationList={getmetaIntegrationList}
                    />
                </GlobalPopUp>
            }
        </>
    )
}

export default CustomRecipient
